import { VREditorSubPanel } from './subpanel.js';
import { Button, FieldLabel } from 'ca-ui';
import * as slugify from 'slugify';
import { InterestRegions } from './components/interest-regions.js';

export class VREditorRoomPanel extends VREditorSubPanel {
  constructor (vr, editor) {
    super(vr, editor, {
      id: 'room',
      name: 'Room',
      instructions: '',
      preview: true,
      assets: vr.assets.rooms,
      assetSelectLabel: 'Room',
      addApplyAssetButton: true,
      addApplyAssetMessage: 'Changing room background, please wait',
      allowAddAsset: false,
      onAssetChange: function (asset) {
        this.setAsset(asset);
      },
      onCreateAssetItem: function (item, asset) {
        item.css(
          'background-image',
          'url(https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/rooms/room_' +
            asset.id +
            '_thumb.png)'
        );
      }
    });

    this.vr = vr;
    this.showPreview(true);
    if (vr.options.roomTitleFirstSaved === undefined) {
      this.vr.options.roomTitleFirstSaved = false;
    }

    if (editor.contentSlug !== undefined || editor.contentSlug !== null) {
      this.editor.slugValid = true;
    }
    const asset = this.vr.getRoomAsset();
    if (!asset) this.setAsset(this.createCustom(this.vr.options.media));
    else this.setAsset(asset);
  }

  initControls () {
    // Yaw
    this.yawLabel = $('<label style="margin-top:20px">Start direction</label>');
    super.append(this.yawLabel);

    this.yawSlider = $(
      '<input class="ca-vr_editorpanel-range" type="range" min="0" max="360" value="0"></input>'
    );
    super.append(this.yawSlider);

    this.yawSlider.on(
      'input',
      function () {
        this.vr.lookAt(-this.yawSlider.val(), 0, 0);
      }.bind(this)
    );

    // Custom
    this.customContainer = new FieldLabel({ label: 'Custom' });
    this.customContainer.el.css('margin-top', '20px');
    super.append(this.customContainer.el);

    this.chooseRenderButton = new Button({
      icon: 'photo-video',
      label: 'Change'
    });
    this.chooseRenderButton.on(
      'click',
      function () {
        console.log('fired by choose media room image button');
        this.vr.editor.openMediaPicker((data) => this.setCustom(data));
      }.bind(this)
    );
    this.customContainer.setField(this.chooseRenderButton);

    // Room Title
    this.roomTitleLabel = $('<label style="margin-top:20px">Room Title</label>');
    super.append(this.roomTitleLabel);

    this.roomTitleTextbox = $(`<input value='${this.getRoomTitleText()}' type="input" maxlength="30" />`);
    this.roomTitleTextbox.on(
      'input',
      function () {
        this.setRoomTitleText(this.roomTitleTextbox.val());
        if (!this.vr.roomTitleFirstSaved) {
          this.roomSlugTextbox.val(this.editor.contentSlug);
        }
      }.bind(this)
    );

    this.roomTitleTextbox.on('blur', function () {
      if (!this.vr.roomTitleFirstSaved) {
        this.checkIfSlugIsValid(this.editor.contentSlug);
      }
    }.bind(this));
    super.append(this.roomTitleTextbox);

    // Room slug
    this.roomSlugLabel = $('<label style="margin-top:20px">Room Slug</label>');
    super.append(this.roomSlugLabel);

    this.roomSlugTextbox = $(`<input value='${this.getRoomSlugText()}' type="input" maxlength="30" />`);
    this.roomSlugTextbox.on(
      'input',
      function () {
        this.setRoomSlugText(this.roomSlugTextbox.val());
      }.bind(this)
    );

    this.roomSlugTextbox.on('blur', function () {
      this.checkIfSlugIsValid(this.roomSlugTextbox.val());
    }.bind(this));
    super.append(this.roomSlugTextbox);
    this.roomSlugError = ($('<span class="error"></span>'));
    super.append(this.roomSlugError);

    this.roomStatusField = new FieldLabel({ label: 'Room Status' });
    super.append(this.roomStatusField.el);

    this.roomStatusSelect = $(`
      <div class='ca-ver-editor_room_status'>
        <div class="ca-ver-editor_room_status_item">
          <input checked='checked' type='radio' id='roomStatusPrivate' name='roomStatus' value='private'>
          <label for='roomStatusPrivate'>Private</label>
        </div>
        <div class="ca-ver-editor_room_status_item">
          <input type='radio' id='roomStatusPublic' name='roomStatus' value='public'>
          <label for='roomStatusPublic'>Public</label>
        </div>
      </div>
    `);

    this.roomStatusSelect.on('change', function () {
      this.vr.setRoomStatus($('input[name="roomStatus"]:checked').val());
    }.bind(this));

    super.append(this.roomStatusSelect);
    this.roomStatusField.setField(this.roomStatusSelect);

    this.editorShowHotspotList = super.createEditorCheckbox(
      'show_hotspot_list_menu',
      'Show Hotspot List Menu'
    );
    // set show welcome value to whatever the vr scene show welcome is, IF it's defined
    this.editorShowHotspotList.change(function () {
      this.setShowHotspotList($('#ca-vr_editor-controls_show_hotspot_list_menu').prop('checked'));
    }.bind(this));

    // eslint-disable-next-line no-undef
    $(this.editorShowHotspotList).prop('checked', vr.options.showHotspotList ? vr.options.showHotspotList : false);

    // Display Top Bar check box
    this.editorShowTopBar = super.createEditorCheckbox(
      'show_top_bar',
      'Show Interest Regions Bar'
    );
    // set show welcome value to whatever the vr scene show welcome is, IF it's defined
    this.editorShowTopBar.change(function () {
      this.setShowTopBar($('#ca-vr_editor-controls_show_top_bar').prop('checked'));
    }.bind(this));

    // eslint-disable-next-line no-undef
    $(this.editorShowTopBar).prop('checked', vr.options.showTopBar ? vr.options.showTopBar : false);

    // configure interest regions
    // Custom
    this.interestRegionsContainer = new FieldLabel({ label: 'Interest Regions' });
    this.interestRegionsContainer.el.css('margin-top', '20px');
    super.append(this.interestRegionsContainer.el);

    this.configureInterestRegions = new InterestRegions({
      icon: ''
    }, this.editor, this.vr, this);

    this.interestRegionsContainer.setField(this.configureInterestRegions);
  }

  openPanel () {
    this.setRoomStatusFields();
  }

  setShowHotspotList (_state) {
    console.log('show hot spot list');
    if (this.vr.options.showHotspotList === undefined) {
      this.vr.options.showHotspotList = true;
    } else {
      this.vr.options.showHotspotList = _state;
    }

    console.log(this.vr.options.showHotspotList);
  }

  setShowTopBar (_state) {
    console.log('set show top bar');
    if (this.vr.options.showTopBar === undefined) {
      this.vr.options.showTopBar = true;
    } else {
      this.vr.options.showTopBar = _state;
    }

    console.log(this.vr.options.showTopBar);
  }

  setRoomStatusFields () {
    if (this.vr.options.status !== undefined) {
      console.log(this.vr.options.status);
      $('[name="roomStatus"]').removeAttr('checked');
      console.log($(`input[name=roomStatus][value="${this.vr.options.status}"]`));
      $(`input[name=roomStatus][value="${this.vr.options.status}"]`).prop('checked', true);
    }
  }

  setAsset (asset) {
    this.preview.css(
      'background-image',
      'url(https://ca-v2.s3.ap-southeast-2.amazonaws.com/ca/virtual-editor/assets/rooms/room_' +
        asset.id +
        '_thumb.png)'
    );

    if (this.vr.getCurrentScene()) {
      if (asset.id === 'custom') {
        this.editor.setImage(`${asset.url}?p=original&fm=jpg&q=50&w=6000`);
        this.editor.setRoomAsset(asset);
        this.preview.css(
          'background-image',
          `url(${asset.url}?p=thumb)`
        );
      } else this.editor.setRoom(asset.id);
    }
  }

  setCustom (data) {
    if (data.url) {
      this.setAsset(this.createCustom(data.url));
    } else {
      this.setAsset(this.createCustom(data.data.url));
    }
  }

  createCustom (url) {
    return {
      id: 'custom',
      name: 'Custom room render',
      keywords: '',
      url: url
    };
  }

  setRoomTitle (roomTitle) {
    this.roomTitle = roomTitle;
    this.roomTitle.text(roomTitle.text);
  }

  setRoomTitleText (roomTitleText) {
    if (this.vr.options.scenes.length > 1) {
      // stub for supporting multiple scenes
      // have found issues with multiple scenes with no content so will need this incase
    } else {
      if (this.vr.options.scenes[0].welcome === undefined) {
        this.vr.options.scenes[0].welcome = {
          heading: '',
          text: ''
        };

        this.vr.options.scenes[0].welcome.heading = roomTitleText;
        this.roomTitleText = roomTitleText;
        this.editor.contentName = roomTitleText;
        if (!this.vr.options.roomTitleFirstSaved) {
          this.setRoomSlugText(roomTitleText);
        }
      } else {
        this.vr.options.scenes[0].welcome.heading = roomTitleText;
        this.roomTitleText = roomTitleText;
        this.editor.contentName = roomTitleText;
        if (!this.vr.options.roomTitleFirstSaved) {
          this.setRoomSlugText(roomTitleText);
        }
      }
    }
  }

  getRoomTitleText () {
    if (this.vr.options.scenes.length > 1) {
      // stub
    } else {
      return this.vr.options.scenes[0].welcome
        ? this.vr.options.scenes[0].welcome.heading
        : '';
    }
    return '';
  }

  getRoomSlugText () {
    if (this.editor.contentSlug !== undefined) {
      return this.editor.contentSlug;
    } else if (this.editor.contentSlug === null || this.vr.options.slug === null) {
      return '';
    } else if (this.vr.options.slug) {
      return this.vr.options.slug;
    }
    return '';
  }

  setRoomSlugText (roomText) {
    if (this.editor.contentSlug === undefined) {
      this.editor.contentSlug = '';
    }
    this.editor.contentSlug = slugify(roomText);
    this.editor.contentSlug = this.editor.contentSlug.toLowerCase();
  }

  checkIfSlugIsValid (slug) {
    $.ajax({
      url: `${this.editor.apiUrl}/projects/${this.editor.projectId}/contents/${slug}`,
      headers: {
        Authorization: 'Bearer ' + this.editor.authToken,
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    })
      .done((data) => {
        if (data.data.id !== this.editor.contentId) {
          this.editor.slugValid = false;
          $(this.roomSlugTextbox)[0].setCustomValidity('Invalid slug. Slug name is already Taken');
          $(this.roomSlugError).text('Invalid slug. Slug name is already Taken');
        } else {
          $(this.roomSlugTextbox)[0].setCustomValidity('');
          $(this.roomSlugError).text('');
          this.editor.slugValid = true;
        }
      })
      .fail(() => {
        this.editor.slugValid = true;
        if (this.roomSlugTextbox.val().match(/^[A-Za-z0-9_-]*$/)) {
          $(this.roomSlugTextbox)[0].setCustomValidity('');
          $(this.roomSlugError).text('');
          this.editor.slugValid = true;
        } else {
          $(this.roomSlugTextbox)[0].setCustomValidity('Invalid characters. Only - and _ special characters are allowed');
          $(this.roomSlugError).text('Invalid characters. Only - and _ special characters are allowed');
          this.editor.slugValid = false;
        }
      })
      .always(() => {
        this.vr.hideLoading();
      });
  }
}
